export class Swatches {
    constructor(container, product, select, pageOptions = null) {
        const options = product.getOptions(),
            count = options.length;
        this.container = container;
        this.product = product;
        this.selectOptions = $(select);
        this.cloneContainer = null;
        this.pageOptions = pageOptions;
        this.productHandle = product.handle();
        this.hasColorOption = false;
        this.hasSizeOption = false;
        this.singleColorVariant = true;
        this.oneColorVariant = false;
        this.oneSizeVariant = false;
        this.selectedColor = null;
        this.hexColors = productsMetaFieldColors[this.productHandle];
        this.productVariants = product.variants();
        this.variantAvailability = this.variantsAvailability(this.productVariants);
        this.availableVariant = this.availableVariant.bind(this);
        this.showMatchedOptions = this.showMatchedOptions.bind(this);
        this.swatchHandle = this.swatchHandle.bind(this);
        this.variantsAvailability = this.variantsAvailability.bind(this);
        this.setFirstAvailableVariant = this.setFirstAvailableVariant.bind(this);
        this.showhideSectionBasedOnAvailability = this.showhideSectionBasedOnAvailability.bind(this);
        this.setSelectOption = this.setSelectOption.bind(this);
        if (options[0].values.length < 2) {
            $('.product-available-js').show();
            $(this.container).html(' ');
            return;
        }
        this.createOptions(options);
        $(this.container).find('.swatcher-color-option-trigger').on('click', this.swatchHandle);
    }

    isObjEmpty (obj) {
        return Object.keys(obj).length === 0;
    }


    variantsAvailability(variants) {
        let result = {};
        for (const variant of variants) {
            result[variant.id] = variant.available;
        }

        return result;
    }

    availableVariant() {
        const variants = this.productVariants;
        let variantsAvailability;
        // checking availability for Color option

        if (this.hasColorOption) {
            variantsAvailability = this.checkSingleSwatchesAvailability(variants, 1);
            this.fillAvailability('Color', variantsAvailability);
        }

        // Checking availability for Size option
        if (this.hasSizeOption && !this.hasColorOption) {
            variantsAvailability = this.checkSingleSwatchesAvailability(variants, 1);
            this.fillAvailability('Size', variantsAvailability);
        }

        // Checking availability for Size option in case where we have color and size option
        if (this.hasSizeOption && this.hasColorOption) {
            const selectedColor = this.getActiveColor();
            variantsAvailability = this.checkSizeBaseOnColorAvailability(selectedColor);
            this.fillAvailability('Size', variantsAvailability);
        }
    }

    createOptions(options) {
        $(this.container).html(' ');
        const { pageOptions } = this;
        for (let i = 0; i < options.length; i++) {
            let firstAvailable = null;
            const option = options[i];
            const optionIndex = i + 1;
            if (option.name === "Color")
                this.hasColorOption = true;
            if (option.name === "Size")
                this.hasSizeOption = true;
            const containerWrapper = document.createElement('div');
            containerWrapper.classList.add('container-wrapper');
            containerWrapper.setAttribute('data-swatches', option.name);
            const swatchesTitle = document.createElement('h6');
            swatchesTitle.classList.add('swatches-title');
            swatchesTitle.textContent = "Select " + option.name.toLowerCase();
            const swatchesContentWrapper = document.createElement('div');
            swatchesContentWrapper.classList.add('swatches-content-wrapper');
            containerWrapper.appendChild(swatchesTitle);
            containerWrapper.appendChild(swatchesContentWrapper);
            for (const optionValue of option.values) {
                const button = document.createElement("button");
                button.classList.add('swatcher-color-option-trigger');
                if (firstAvailable === null) {
                    button.classList.add('active');
                    button.setAttribute('data-target', true);
                } else {
                    button.setAttribute('data-target', true);
                }

                button.setAttribute('data-swatch-handle', optionValue);
                button.setAttribute('data-option-index', optionIndex);

                if (option.name === "Color") {
                    button.style.background = this.getHexColor(optionValue);
                }

                if (option.name === "Size") {
                    button.textContent = optionValue;
                    if (this.hasColorOption) {
                        button.classList.add('d-none');
                    }
                }
                swatchesContentWrapper.appendChild(button);
                firstAvailable = true;
            }
            
            this.container.append(containerWrapper);
        }
        this.setFirstAvailableVariant();
        this.showMatchedOptions();
        if (!pageOptions.hasOwnProperty('class_ProductPage')) {
            this.availableVariant();
        }
    }

    getHexColor(colorName) {
        const { hexColors } = this;
        if(hexColors === null)
            return colorName;

    
        if(hexColors[colorName].includes('|')){
            const gradiantColors = hexColors[colorName].split('|');
            if(gradiantColors.length === 2) {
                return `linear-gradient(90deg, ${gradiantColors[0]} 0%,  ${gradiantColors[0]} 50%, ${gradiantColors[1]} 50%)`;
            } else if(gradiantColors.length === 3) {
                return `linear-gradient(90deg, ${gradiantColors[0]} 0%,  ${gradiantColors[0]} 33%, ${gradiantColors[1]} 33%, ${gradiantColors[1]} 65%, ${gradiantColors[2]} 65%)`;
            } else {
                return colorName;
            }
            // for(let i = 0; i < gradiantColors.length; i++) {
            //     const gradiantColor = gradiantColors[0];
            //     console.log("gradiantColor: " + gradiantColor);
            // }
        } else {
            return hexColors[colorName] ? hexColors[colorName] : colorName;
        }
    }

    showMatchedOptions() {
        const handle = this.container.find('[data-swatches="Color"] .swatcher-color-option-trigger.active').data('swatch-handle'), {productVariants} = this;
        let hasOptionSize = false;
        for (const variant of productVariants) {
            if (variant.option2 !== null) {
                if (!hasOptionSize) {
                    $(this.container).find(`[data-option-index="2"]`).addClass('d-none');
                }
                hasOptionSize = true;
                if (variant.option1 === handle) {
                    const optionSize = $(this.container).find(`[data-swatch-handle="${variant.option2}"]`);
                    optionSize.removeClass('d-none');
                }
            }
        }
    }

    variantContainsOption(colorOption, sizeOption) {
        const {productVariants} = this;
        let result = false;
        for (const variant of productVariants) {
            if (variant.option1 === colorOption && sizeOption === variant.option2)
                result = true;
        }

        return result;
    }

    swatchHandle(e) {
        e.preventDefault();
        const target = $(e.currentTarget), {productVariants} = this,
            handle = target.data('swatch-handle'),
            optionIndex = target.data('option-index').toString(),
            selectedOption = 'option' + optionIndex;
        $('.v4-add-to-cart-popup').attr('data-popup-variant-name', handle);
        $('.v4-single-product-section .featured .carousel-inner').attr('data-active-variant', handle);
        let firstAvailable = false;
        if (optionIndex === '1') {
            if(this.pageOptions.hasOwnProperty('class_ProductPage'))
                $('.v4-single-product-section .v4-quantity-selector .step-button.up').prop('disabled', false);
            else
                $('.v4-add-to-cart-popup .v4-quantity-selector .step-button.up').prop('disabled', false);
            $(this.container).find('.swatcher-color-option-trigger').removeClass('active');
            $(this.container).find('.swatcher-color-option-trigger').attr('data-target', false);
            for (const variant of productVariants) {
                if (firstAvailable) {
                    break;
                }
                if (variant[selectedOption] === handle) {
                    this.setSelectOption(variant.id);
                    // if (variant.option1 === "Black" || variant.option1 === "White")
                        this.changeImage(variant.option1);
                    this.showhideSectionBasedOnAvailability(true);
                    const option1 = $(this.container).find(`[data-swatch-handle="${variant.option1}"]`);
                    option1.attr('data-target', true);
                    option1.addClass('active');
                    if (variant.option2 !== null) {
                        const option2 = $(this.container).find(`[data-swatch-handle="${variant.option2}"]`);
                        option2.attr('data-target', true);
                        option2.addClass('active');
                    }

                    firstAvailable = true;
                }
            }

            this.showMatchedOptions();
        } else if (optionIndex === '2') {
            const selectedColor = $(this.container).find('.container-wrapper[data-swatches="Color"] .swatcher-color-option-trigger.active').attr('data-swatch-handle');
            $(this.container).find('.container-wrapper[data-swatches="Size"] .swatcher-color-option-trigger').removeClass('active');
            $(this.container).find('.container-wrapper[data-swatches="Size"] .swatcher-color-option-trigger').attr('data-target', false);

            for (const variant of productVariants) {
                if (variant[selectedOption] === handle && selectedColor === variant.option1) {
                    this.setSelectOption(variant.id);
                    this.showhideSectionBasedOnAvailability(true);
                    if (variant.option2 !== null) {
                        const option2 = $(this.container).find(`[data-swatch-handle="${variant.option2}"]`);
                        option2.attr('data-target', true);
                        option2.addClass('active');
                    }
                }
            }
        }

        if (!this.pageOptions.hasOwnProperty('class_ProductPage')) {
            this.availableVariant();
        }
    }

    setSelectOption(id) {
        this.selectOptions.find('option').attr('selected', false);
        const selectedVariant = this.selectOptions.find(`option[value="${id}"]`).val();
        this.selectOptions.find(`option[value="${id}"]`).attr('selected', 'selected');
        this.selectOptions.val(selectedVariant);
        this.selectOptions.change();
    }

    setFirstAvailableVariant() {
        const {productVariants, selectOptions} = this, urlVariant = this.findGetParameter('variant');
        let selectedVariant = selectOptions.val()
        if (urlVariant !== null)
            selectedVariant = urlVariant;
        for (const variant of productVariants) {
            if (selectedVariant == variant.id) {
                $(this.container).find('.swatcher-color-option-trigger').attr('data-target', false);
                $(this.container).find('.swatcher-color-option-trigger').removeClass('active');
                const option1 = $(this.container).find(`[data-swatch-handle="${variant.option1}"]`);
                option1.attr('data-target', true);
                option1.addClass('active');
                $('.v4-add-to-cart-popup').attr('data-popup-variant-name', variant.option1);
                if (variant.option2 !== null) {
                    const option2 = $(this.container).find(`[data-swatch-handle="${variant.option2}"]`);
                    option2.attr('data-target', true);
                    option2.addClass('active');
                }
            }
        }

        this.showhideSectionBasedOnAvailability();
        if (productVariants.length > 1)
            $(this.container).removeClass('d-none');

        this.initImageSlider();
    }

    showhideSectionBasedOnAvailability(isClicked = false) {
        const {variantAvailability, selectOptions} = this, urlVariant = this.findGetParameter('variant');
        let selectedVariant = $(selectOptions).find('option:selected').val();
        if (urlVariant !== null && !isClicked && !this.isObjEmpty(this.pageOptions))
            selectedVariant = urlVariant;
        const selectedVariantAvailability = variantAvailability[selectedVariant];
        if (selectedVariantAvailability) {
            $('.product-unavailable-js').hide();
            $('.product-available-js').show();
        } else {
            $('.product-unavailable-js').show();
            $('.product-available-js').hide();
        }
    }

    initImageSlider() {
        const activeVariant = this.selectOptions.val(),
            activeSwatchArr = $(this.container).find('.swatcher-color-option-trigger.active'),
            activeSwatch = activeSwatchArr.attr('data-swatch-handle');
        this.selectOptions.find('option').attr('selected', false);
        const selectedVariant = this.selectOptions.find(`option[value="${activeVariant}"]`).val();
        this.selectOptions.find(`option[value="${activeVariant}"]`).attr('selected', 'selected');
        this.selectOptions.val(selectedVariant);
        this.selectOptions.change();
        this.changeImage(activeSwatch);
    }

    getActiveColor() {
        const container = this.container.find('[data-swatches="Color"]'),
            activeSize = container.find('[data-target="true"]').data('swatch-handle');
        if (activeSize !== undefined)
            return activeSize;
        else
            return null;
    }

    getActiveSize() {
        const container = this.container.find('[data-swatches="Size"]'),
            activeSize = container.find('[data-target="true"]').data('swatch-handle');
        if (activeSize !== undefined)
            return activeSize;
        else
            return null;
    }

    fillAvailability(swatchesOption, availableVariants) {
        const colorContainer = this.container.find('[data-swatches="' + swatchesOption + '"]'),
            swatches = colorContainer.find('.swatcher-color-option-trigger'),
            {productVariants} = this;

        for (let i = 0; i < swatches.length; i++) {
            const swatch = $(swatches[i]),
                handle = swatch.data('swatch-handle');
            if (!availableVariants[handle]) {
                swatch.addClass('not-available');
                swatch.prop('disabled', true);
                if (swatch.hasClass('active')) {
                    swatch.removeClass('active');
                    swatch.attr('data-target', false);
                }
            } else {
                swatch.removeClass('not-available');
                swatch.prop('disabled', false);
            }
        }
    }

    checkSizeBaseOnColorAvailability(selectedColor) {
        const {productVariants} = this;
        let variantsAvailability = [];
        for (let i = 0; i < productVariants.length; i++) {
            const variant = productVariants[i];
            if (variant.option1 === selectedColor) {
                if (variant.available) {
                    variantsAvailability[variant.option2] = true;
                } else {
                    if (!variantsAvailability.hasOwnProperty(variant.option1)) {
                        variantsAvailability[variant.option2] = false;
                    }
                }
            }
        }
        return variantsAvailability;
    }

    checkSingleSwatchesAvailability(variants, option) {
        let variantsAvailability = [];
        for (let i = 0; i < variants.length; i++) {
            const variant = variants[i];
            let variantOption = '';
            if (option === 1) {
                variantOption = variant.option1;
            } else if (option === 2) {
                variantOption = variant.option2;
            }
            if (variant.available) {
                variantsAvailability[variantOption] = true;
            } else {
                if (!variantsAvailability.hasOwnProperty(variantOption)) {
                    variantsAvailability[variantOption] = false;
                }
            }
        }

        return variantsAvailability;
    }

    findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }

        return result;
    }

    changeImage(alt) {
        const selectedImage = $(".image-frame .data_object[alt*='" + alt + "']");
        if (selectedImage.length > 0) {
            $(".data_object").attr('data-visible', false);
            selectedImage.attr('data-visible', true);
            const trigger = $(".strip .data_object[data-image-alt*='" + alt + "']");
            trigger.attr('data-visible', true);
            $('#dots-wrapper .dot-control').removeClass('active');
            $("#dots-wrapper .dot-control[data-image-alt*='" + alt + "']").addClass('active');
            
            trigger.eq(0).click();
        }
    }
}